export const CARD_METHOD   = 'card';
export const DRIVER_METHOD = 'driver';
